/**
 * How a file size reads on a timeline row.
 *
 * Rounded hard and deliberately imprecise: the number is there to answer "is
 * this the photo or the whole catalogue" before somebody clicks, and "1.4 MB"
 * answers that as well as "1,438,221 bytes" does while fitting on the row.
 */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}
